// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"f4d35a08","328":"662a2aa5","649":"a63c5774","737":"b21634a0","946":"f4d35a08"}[chunkId] + ".chunk.css";
};